import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Redirect} from 'react-router-dom'
import '../assets/App.css'
import {
    Row,
    Col,
    Grid,
    Panel,
    Button,
    PanelBody,
    PanelContainer,
    Icon,
} from '@sketchpixy/rubix'

class Contact extends Component {
    constructor(props) {
        super(props)
        this.state = {
            authenticate: !!this.props.loginToken,
        }
    }

    componentDidMount() {
        
    }

    componentWillReceiveProps(newProps) {
        if (newProps.loginToken) {
            this.setState({authenticate: true})
        }
    }

    actions = link => {
        const {history} = this.props
        history.push(link)
    }

    render() {
        const {
            authenticate,
        } = this.state
        // const {role} = this.props
        let {from} = this.props.location.state || {from: '/admin/dashboard'}

        if (authenticate) {
            return (
                <Redirect to={from}/>
            )
        }

        return (
            <div id='auth-container' className='login bgImage'>
                <div id='#auth-row-0'>
                    <div id='auth-cell'>
                        <Grid>
                            <Row>
                                <Col className="bg-white  app-logo" sm={6} smOffset={0} xs={6} xsOffset={0} collapseLeft collapseRight>
                                    <a href="/" style={{paddingLeft: '15px'}}>
                                        <img style={{top: '-12px', margin: '0'}} src="/imgs/app/LogoSmall.svg" width="150"
                                            alt="" height="70"/>
                                    </a>
                                </Col>
                                
                            </Row>
                            <Row>
                                <Col className="splash-body" sm={6} smOffset={0} xs={6} xsOffset={0} collapseLeft collapseRight>
                                    <Col className="splash-container">
                                    <PanelContainer controls={false} className="bg-custom-colot-blue">
                                        <Panel className="bg-custom-colot-blue">
                                            <PanelBody style={{padding: 0, marginTop: 75}}>
                                                <div className='text-center fg-darkblue'>
                                                    <h1 className='heading-main' >Welcome to FASTVet</h1>
                                                </div>
                                                <div className='text-center'
                                                     style={{padding: 12.5}}>
                                                    <h3>Join a Network to begin</h3>
                                                </div>
                                                <div className='text-center'>
                                                    <div className='text-center' style={{
                                                        padding: 25,
                                                        paddingTop: 0,
                                                        paddingBottom: 0,
                                                        margin: 'auto',
                                                        marginBottom: 25,
                                                        marginTop: 75
                                                    }}>
                                                        <Button
                                                            lg
                                                            type='button'
                                                            bsStyle='primary'
                                                            className="bg-darkblue"
                                                            onClick={this.actions.bind(this, `/login`)}
                                                        ><svg style={{marginLeft: '10px', marginRight: '60px'}} xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-globe" viewBox="0 0 16 16">
                                                        <path d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm7.5-6.923c-.67.204-1.335.82-1.887 1.855A7.97 7.97 0 0 0 5.145 4H7.5V1.077zM4.09 4a9.267 9.267 0 0 1 .64-1.539 6.7 6.7 0 0 1 .597-.933A7.025 7.025 0 0 0 2.255 4H4.09zm-.582 3.5c.03-.877.138-1.718.312-2.5H1.674a6.958 6.958 0 0 0-.656 2.5h2.49zM4.847 5a12.5 12.5 0 0 0-.338 2.5H7.5V5H4.847zM8.5 5v2.5h2.99a12.495 12.495 0 0 0-.337-2.5H8.5zM4.51 8.5a12.5 12.5 0 0 0 .337 2.5H7.5V8.5H4.51zm3.99 0V11h2.653c.187-.765.306-1.608.338-2.5H8.5zM5.145 12c.138.386.295.744.468 1.068.552 1.035 1.218 1.65 1.887 1.855V12H5.145zm.182 2.472a6.696 6.696 0 0 1-.597-.933A9.268 9.268 0 0 1 4.09 12H2.255a7.024 7.024 0 0 0 3.072 2.472zM3.82 11a13.652 13.652 0 0 1-.312-2.5h-2.49c.062.89.291 1.733.656 2.5H3.82zm6.853 3.472A7.024 7.024 0 0 0 13.745 12H11.91a9.27 9.27 0 0 1-.64 1.539 6.688 6.688 0 0 1-.597.933zM8.5 12v2.923c.67-.204 1.335-.82 1.887-1.855.173-.324.33-.682.468-1.068H8.5zm3.68-1h2.146c.365-.767.594-1.61.656-2.5h-2.49a13.65 13.65 0 0 1-.312 2.5zm2.802-3.5a6.959 6.959 0 0 0-.656-2.5H12.18c.174.782.282 1.623.312 2.5h2.49zM11.27 2.461c.247.464.462.98.64 1.539h1.835a7.024 7.024 0 0 0-3.072-2.472c.218.284.418.598.597.933zM10.855 4a7.966 7.966 0 0 0-.468-1.068C9.835 1.897 9.17 1.282 8.5 1.077V4h2.355z"/>
                                                      </svg> Sign In  <Icon style={{marginLeft: '60px', marginRight: '10px'}}
                                                        glyph='glyphicon-menu-right'/></Button>
                                                    </div>
                                                </div>
                                            </PanelBody>
                                        </Panel>
                                    </PanelContainer>
                                    </Col>
                                </Col>
                            </Row>
                            <Row className="text-bottom-splash">
                                {/*<Col className="text-bottom-color bg-white" sm={6} smOffset={0} xs={6} xsOffset={0} collapseLeft collapseRight>
                                    <span >&copy; 2020 Veteran Benefits Guide</span>
                                     <Col className="text-bottom-color bg-white" sm={6} smOffset={0} xs={6} xsOffset={0} collapseLeft collapseRight>
                                    <ul className='splash-li'>
                                        <li><a href="">ets</a></li>
                                        <li><a href="">sda</a></li>
                                    </ul>
                                </Col>
                                </Col>*/}
                               <div className="col-md-6">
                                    <div className='col-md-6  bg-white'>
                                         <span >&copy; 2023 Veteran Benefits Guide</span>
                                        </div>
                                        <div className='col-md-6 text-bottom-color bg-white'>
                                        <ul className='splash-li text-bottom-color'>
                                        <li><a style={{cursor:'pointer'}} onClick={this.actions.bind(this, `/terms`)}>Terms & Conditions</a></li>
                                        <li><a style={{cursor:'pointer'}} onClick={this.actions.bind(this, `/contact`)}>Contact Us</a></li>
                                    </ul>
                                        </div>
                                   </div>
                            </Row>
                        </Grid>
                    </div>
                </div>
            </div>
        )
    }
}

const
    mapStateToProps = ({login}) => {
        const {loginToken} = login
        return {loginToken}
    }

const
    mapDispatchToProps = dispatch => ({
        
    })

export default connect(mapStateToProps, mapDispatchToProps)(Contact)
